<template>
    <div>
        <div class="md-layout md-gutter">
            <div class="md-layout-item md-size-45">
                <div>
                    <span class="font-bold">Numéro :</span>
                    {{ contract.number }}
                </div>
                <div>
                    <span class="font-bold mr-1">Actif :</span>
                    <span :class="contract.is_active ? 'text-success' : 'text-danger'">{{ isActive(contract.is_active) }}</span>
                </div>
                <div>
                    <span class="font-bold mr-1">Tacite reconduction :</span>
                    <span :class="contract.is_tacit ? 'text-success' : 'text-danger'">{{ isActive(contract.is_tacit) }}</span>
                </div>
                <div>
                    <span class="font-bold">Date de création :</span>
                    {{ this.$moment(contract.created_at).format('DD/MM/YYYY') }}
                </div>
                <div>
                    <span class="font-bold">Début de la relation client :</span>
                    {{ contract.client_relation ? contract.client_relation : 'Ø' }}
                </div>
            </div>
            <div class="md-layout-item md-size-55">
                <div class="mt-2">
                    <span class="font-bold">Facturation :</span>
                    {{ billingMonths(contract.billing_months) }}
                </div>
                <div class="">
                    <span class="font-bold">Informations de facturation :</span>
                    {{ contract.billing_info ? contract.billing_info : 'Ø' }}
                </div>
                <div class="">
                    <span class="font-bold">Commentaire :</span>
                    {{ contract.comment ? contract.comment : 'Ø' }}
                </div>
            </div>
        </div>
        <div class="md-layout md-gutter mt-2">
            <div class="md-layout-item md-size-45">
                <div class="md-layout">
                    <div class="md-layout-item md-size-100 pl-0">
                        <p class="font-bold text-info">Détails des périodes</p>
                        <div>
                            <span class="font-bold">Durée prévue de chaque période :</span>
                            {{ contract.period_duration + ' mois' }}
                        </div>
                        <div>
                            <span class="font-bold">Durée d'engagement :</span>
                            {{ (contract.period_repetition || contract.period_repetition === 0) ? (12 + (12 * contract.period_repetition)) + ' mois' : 'Ø' }}
                        </div>
                    </div>
                </div>
            </div>
            <div class="md-layout-item md-size-55">
                <div class="md-layout">
                    <div class="md-layout-item md-size-100 pl-0">
                        <p class="font-bold text-info">
                            <template>
	                            <span v-if="period.type === 'current_period'">Période en cours</span>
	                            <span v-else-if="period.type === 'next_period'">Période à venir</span>
	                            <span v-else>Dernière période <span v-if="period.is_canceled">(résiliée)</span></span>
                            </template>
                            <span v-if="contract.period_repetition > 0" class="text-black font-normal text-xs">
                                {{ '(' + (contract.periods.findIndex((p) => p.id === period.id) + 1) + ' sur ' + (contract.period_repetition + 1) + ')' }}
                            </span>
                        </p>
                        <div class="md-layout">
                            <div class="md-layout-item md-size-50 pl-0">
                                <span class="font-bold">Date de début :</span>
                                {{ $moment(period.date_start).format('DD/MM/YYYY') }}
                            </div>
                            <div class="md-layout-item md-size-50 pl-0">
                                <span class="font-bold">Date de résiliation :</span>
                                {{ period.is_canceled
                                    ? $moment(period.cancel_date).format('DD/MM/YYYY')
                                    : 'Ø'
                                }}
                            </div>
                        </div>
                        <div class="md-layout">
                            <div class="md-layout-item md-size-50 pl-0">
                                <span class="font-bold">Date de fin :</span>
                                {{ period.date_end ? $moment(period.date_end).format('DD/MM/YYYY') : 'Ø' }}
                            </div>
                            <div class="md-layout-item md-size-50 pl-0">
                                <span class="font-bold">Raison de la résiliation :</span>
                                {{ period.is_canceled && period.cancel_type
                                    ? period.cancel_type.name
                                    : 'Ø'
                                }}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "ContractInformations",
    props: {
        contract: Object
    },
    computed: {
        period() {
			const periodType = this.contract.current_period ? 'current_period' : (this.contract.next_period ? 'next_period' : 'last_period')
            return {
                id: this.contract[periodType].id,
                date_start: this.contract[periodType].date_start,
                date_end: this.contract[periodType].date_end,
                is_canceled: this.contract[periodType].is_canceled,
                cancel_type_id: this.contract[periodType].cancel_type_id,
                cancel_date: this.contract[periodType].cancel_date,
                cancel_type: this.contract[periodType].cancel_type,
                type: periodType
            }
        },
    },
    methods: {
        isActive(state) {
            return state ? 'Oui' : 'Non'
        },
        billingMonths(months) {
            let monthNumbers = months.split(',')
            let facturation = ''
            monthNumbers.map((month, i) => {
                facturation += this.$moment().month(parseInt(month)).format('MMMM').charAt(0).toUpperCase() + this.$moment().month(parseInt(month)).format('MMMM').slice(1)
                if(i !== (monthNumbers.length - 1)) facturation += ', '
            })
            return facturation
        },
    }
}
</script>

<style scoped lang="scss">
::v-deep {
    .md-layout.md-gutter {
        margin: 0;
        .md-layout-item {
            padding: 0 10px;

            &:first-child {
                padding-left: 0;
            }

            &:last-child {
                padding-right: 0;
            }
        }
    }
}
</style>
